import {css} from '@sail/engine/deprecated';
import {LinkTheme, linkColors} from './link';
import {Theme} from './theme';

export const linkAssistantColors = {
  ...linkColors,
};

export const LinkAssistantTheme: Theme = {
  ...LinkTheme,
  buttonBackgroundImage: `linear-gradient(white, white), linear-gradient(${linkAssistantColors.neutralBorder}, ${linkAssistantColors.neutralBorder})`,
  buttonBorderWidth: '1px',
  buttonHoverColor: linkAssistantColors.brand600,
  messageBubbleBackground: linkAssistantColors.brand600,
  messageBubbleText: linkColors.neutral,
  primaryActionColor: linkColors.neutral900,
  pressedShadow: linkColors.brand1000,
  articleHeadingsColor: linkAssistantColors.articleHeading,
  articleLinkColor: linkAssistantColors.neutral900,
  onCtaTextColor: linkColors.neutral,
  ctaColor: linkColors.neutral900,
  ctaHoverColor: linkColors.neutral900,
  focusVisibleOutline: css.value(`2px solid ${linkColors.neutral900}`),
  formBorderColor: linkColors.neutralBorder,
  useCustomPlaceholder: true,
  textFieldPaddingTop: '20px',
  textFieldPaddingBottom: '4px',
  textFieldPaddingLeft: '16px',
  textFieldPaddingRight: '16px',
  textFieldLineHeight: '24px',
  textFieldHeight: '56px',
  textFieldFontSize: '16px',
  textFieldFontWeight: '400',
  customPlaceholderColor: linkColors.neutral500,
  customPlaceholderTopFocused: '-48px',
  customPlaceholderTopUnfocused: '-40px',
  customPlaceholderLeft: '16px',
  customPlaceholderFontSizeFocused: '12px',
  customPlaceholderFontSizeUnfocused: '16px',
  customPlaceholderTransition: '0.2s ease all',
  customPlaceholderFontWeight: '400',
};
